import React from 'react'
import { Redirect } from 'react-router-dom'
import { LocalStorageService } from '../../services'

const ProtectedRoute = ({ children, requireAdmin = false, ...routeProps }) => {
  const localStorageService = new LocalStorageService()

  try {
    const user = localStorageService.getLocalStorageItem('user')
    
    if (!user || !user.userMetaData || !user.userMetaData.userRoles) {
      return <Redirect to="/" />
    }

    // Use the same logic as the Context
    const userRoles = user.userMetaData.userRoles
    const isAdmin = userRoles.find(userRole => 
      userRole.role.key === process.env.REACT_APP_ROLE_GENERAL_ADMIN
    )

    // If admin is required and the user is not an admin, redirect
    if (requireAdmin && !isAdmin) {
      return <Redirect to="/" />
    }

    return children
  } catch (error) {
    console.error('Error al validar acceso a ruta:', error)
    return <Redirect to="/" />
  }
}

export { ProtectedRoute as default }